import React from 'react'
import { Box, Chip, Grid } from '@mui/material'
import Field from './Field'
import RowActions from './RowActions'

export const emptyPrize = { name: '', quantity: 1, winnersPerDraw: 1 }

/**
 * One prize inside a group, as a run of Grid items for the card holding the group's prize list.
 *
 * `name` is the field-array path this row edits, e.g. `groups.0.prizes.2`. `number` is its running
 * position across the whole draw — the order the draw screen walks — not its position in the group.
 * `canRemove` is whether the group would still have a prize left; an awarded prize is pinned
 * regardless, because its winners are already recorded against it.
 */
const PrizeRow = ({
  control,
  name,
  number,
  awarded,
  isFirst,
  isLast,
  canRemove,
  onMoveUp,
  onMoveDown,
  onClone,
  onRemove,
}) => {
  const isAwarded = awarded > 0

  return (
    <>
      <Grid item xs={12}>
        {/* The negative mx cancels CardContent's padding so the band reaches the card's sides, so
            the two have to match; px puts the contents back in line with the fields below. Only the
            first band also cancels the top padding, to cap the card. */}
        <Box
          sx={{
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mx: -3,
            mt: isFirst ? -3 : 2,
            mb: 1,
            px: 3,
            py: 2,
          }}
        >
          {/* Prize roll order number */}
          <Chip
            label={number}
            sx={{
              backgroundColor: '#f7c948',
              color: '#101010',
              fontWeight: 700,
              fontSize: '0.85rem',
            }}
          />
          <RowActions
            onUp={onMoveUp}
            onDown={onMoveDown}
            isFirst={isFirst}
            isLast={isLast}
            onClone={onClone}
            onRemove={onRemove}
            canRemove={!isAwarded && canRemove}
            removeTitle={isAwarded ? 'Already awarded — cannot remove' : 'Remove prize'}
            iconSize='small'
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field control={control} name={`${name}.name`} label='Prize' />
      </Grid>
      <Grid item xs={6} sm={3}>
        <Field
          control={control}
          name={`${name}.quantity`}
          label='Quantity'
          type='number'
          helper={isAwarded ? `${awarded} awarded` : ''}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <Field
          control={control}
          name={`${name}.winnersPerDraw`}
          label='Winners Per Draw'
          type='number'
        />
      </Grid>
    </>
  )
}

export default PrizeRow
